module.exports = __webpack_public_path__ + "static/img/home_services_integ.dc362c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_services_integ.svg
// module id = 165
// module chunks = 2